import React from 'react';
import { urlPubblica } from './apiPubblica';
import { Contenitore, Intestazione, SedePubblica } from './Componenti';
import { AspettoPagina, TemaPagina } from './aspetto';
import { formatDataRoma } from '../utils/dateRoma';

// Dati della pagina di prenotazione aperta (stessa forma di `datiPagina` del backend).
export interface DatiPagina {
  stato: 'APERTA' | 'CHIUSA';
  tokenPagina: string | null;
  sede: SedePubblica | null;
  cantiere?: { nome: string; impresa: string; indirizzo: string | null };
  scadenzaScelte?: string | null;
  testoBenvenuto?: string | null;
  haBrochure?: boolean;
  buoni?: { atrio: string | null; aran: string | null };
  acquirente?: { nome: string };
  venditore?: { nome: string } | null;
  aspetto?: AspettoPagina;
}

interface Props {
  dati: DatiPagina;
  modalita: 'pagina' | 'acquirente';
  tema: TemaPagina | null;
  // Il blocco di prenotazione: gli orari e il modulo, oppure (nell'anteprima) un riquadro fisso.
  prenotazione: React.ReactNode;
  anteprima?: boolean;
}

// La pagina standard di BOP, usata quando il cantiere non ha un modello (o il modello non si può mostrare).
export default function PaginaStandard({ dati, modalita, tema, prenotazione, anteprima = false }: Props) {
  return (
    <Contenitore tema={tema} anteprima={anteprima}>
      <Intestazione sede={dati.sede} tokenPagina={dati.tokenPagina} logoImpresa={tema?.logoImpresa} nomeImpresa={dati.cantiere?.impresa} />

      <div className="bop-pubblico__card">
        <h1 className="bop-pubblico__titolo">
          {modalita === 'acquirente' && dati.acquirente ? `Ciao ${dati.acquirente.nome}, prenota il prossimo incontro` : 'Prenota il tuo primo incontro'}
        </h1>
        {dati.cantiere && <p className="bop-pubblico__testo">{dati.cantiere.nome}{dati.cantiere.indirizzo ? ` – ${dati.cantiere.indirizzo}` : ''} · {dati.cantiere.impresa}</p>}
        {modalita === 'acquirente' && dati.venditore && <p className="bop-pubblico__testo">Ti aspetta {dati.venditore.nome}.</p>}
        {dati.scadenzaScelte && <p className="bop-pubblico__testo">Le scelte delle finiture vanno completate entro il {formatDataRoma(dati.scadenzaScelte)}.</p>}
        {dati.testoBenvenuto && <p className="bop-pubblico__testo">{dati.testoBenvenuto}</p>}
        {dati.haBrochure && dati.tokenPagina && (
          <a className="bop-pubblico__link" href={urlPubblica(`/api/pubblico/prenotazioni/${encodeURIComponent(dati.tokenPagina)}/brochure`)} target="_blank" rel="noreferrer">Guarda la brochure del capitolato</a>
        )}
      </div>

      {modalita === 'pagina' && (
        <>
          <div className="bop-pubblico__card">
            <h2 className="bop-pubblico__titolo">Come funziona</h2>
            <ol className="bop-pubblico__passi">
              <li className="bop-pubblico__passo">Ci sediamo insieme: ci racconti come vivrai la casa e ti mostriamo il capitolato.</li>
              <li className="bop-pubblico__passo">Ti spieghiamo come funzionano le personalizzazioni oltre il capitolato.</li>
              <li className="bop-pubblico__passo">In 2 o 3 incontri scegli tutto con calma, con lo stesso venditore.</li>
            </ol>
          </div>
          <div className="bop-pubblico__card">
            <h2 className="bop-pubblico__titolo">Al primo incontro riceverai</h2>
            <div className="bop-pubblico__vantaggi">
              <div className="bop-pubblico__vantaggio">
                <p className="bop-pubblico__vantaggio-titolo">Consulenza gratuita Atrio</p>
                <p className="bop-pubblico__testo">Un interior designer ti aiuta a immaginare la casa finita e a scegliere con più sicurezza.</p>
                {dati.buoni?.atrio && <p className="bop-pubblico__testo">{dati.buoni.atrio}</p>}
              </div>
              <div className="bop-pubblico__vantaggio">
                <p className="bop-pubblico__vantaggio-titolo">300 € reali su una cucina Aran</p>
                <p className="bop-pubblico__testo">Vai da Aran quando vuoi e usi lo sconto alla firma, sul prezzo normale, senza ricarichi.</p>
                {dati.buoni?.aran && <p className="bop-pubblico__testo">{dati.buoni.aran}</p>}
              </div>
            </div>
          </div>
        </>
      )}

      {prenotazione}
    </Contenitore>
  );
}
